import React from 'react';
import { gotoSubscriptionInfoOrOverview } from 'actions/Subscription';
import SubscriptionBadge from 'components/Subscription/SubscriptionBadge';
import Navigation from 'components/UI/Navigation';
import NavItem from 'components/UI/NavItem';
import { SidebarMenu } from 'navigation';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch } from 'react-redux';
import { FEATURES, isFeatureEnabled } from 'utilities/features';
function MainNavigation({ showArtisanFoodPageLink, subscriptionEnabled, }) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    return (React.createElement(Navigation, { className: "main-navigation", type: "row" },
        React.createElement(NavItem, null,
            React.createElement(SidebarMenu, null)),
        showArtisanFoodPageLink && (React.createElement(NavItem, { to: '/handverksmat' }, "H\u00E5ndverksmat")),
        React.createElement(NavItem, { to: "/supplier" }, t('navigationMainNavigationSuppliers')),
        subscriptionEnabled && (React.createElement(NavItem, { to: "#", callback: (_e) => dispatch(gotoSubscriptionInfoOrOverview()) },
            React.createElement("span", null, t('navigationMainNavigationSubscription')),
            React.createElement(SubscriptionBadge, null))),
        React.createElement(NavItem, { to: "/bedrift", scrollToTop: true }, t('navigationMainB2B'))));
}
const mapStateToProps = ({ features, region }) => {
    const showArtisanFoodPageLink = (region.slug === 'oslo' || region.slug === 'stavanger');
    return {
        showArtisanFoodPageLink: showArtisanFoodPageLink,
        subscriptionEnabled: isFeatureEnabled(features, FEATURES.SUBSCRIPTION),
    };
};
export default connect(mapStateToProps)(MainNavigation);
